import { X } from 'lucide-react';
import { useListContext, useTranslate } from 'ra-core';
import { FilterButton } from '../../components/admin/filter-form';
import { Button } from '../../components/ui/button';

/** Actions alongside the live filter inputs, within the kit's FilterContext. */
export function MoonstarListFilterActions() {
  const { filterValues, setFilters } = useListContext();
  const translate = useTranslate();
  const hasFilters = Object.values(filterValues).some(
    (value) =>
      value != null &&
      value !== '' &&
      (!Array.isArray(value) || value.length > 0)
  );

  return (
    <div className="flex flex-wrap items-center gap-2">
      <FilterButton
        className={
          hasFilters
            ? '[&_button]:border-primary/20 [&_button]:bg-accent [&_button]:text-accent-foreground'
            : undefined
        }
      />
      {hasFilters && (
        <Button
          type="button"
          variant="ghost"
          className="text-muted-foreground"
          onClick={() => setFilters({}, {})}
        >
          <X className="size-4" />
          {translate('moonstar.list.clearFilters', { _: 'Clear filters' })}
        </Button>
      )}
    </div>
  );
}
